import { Component, Input } from '@angular/core';
import { CardItem } from 'src/app/shared/models/ui-card.model';

@Component({
    selector: 'ui-card',
    templateUrl: './ui-card.component.html',
    styleUrls: ['./ui-card.component.scss'],
    standalone: false
})
export class UiCardComponent {
  @Input() item: CardItem = {};

  getCardStyles(): Record<string, string> {
    const styles: Record<string, string> = {
      color: this.getTextColor(),
    };

    if (this.getBackgroundType() === 'image') {
      styles['background-image'] = `url('${this.getBackground()}')`;
      styles['background-size'] = 'cover';
      styles['background-position'] = 'center';
      styles['background-repeat'] = 'no-repeat';
    } else {
      styles['background'] = this.getBackground();
    }

    return styles;
  }

  getBackgroundType(): string {
    return this.item.backgroundType || 'color';
  }
  getBackground(): string {
    if (this.item.background) {
      return this.item.background;
    } else {
      return 'var(--surface-section)';
    }
  }

  getTextColor(): string {
    return this.item.textColor || 'var(--text-color)';
  }
}
